import React from 'react';
import './Calc.css';

const Calc = (props) => {

  const onCalcRate = (e) => {
    e.preventDefault();
    let elements = e.target.elements;
    let countCurrency = elements['count-currency'].value;
    let typeCurrency = elements['type-currency'].value;
    let calculated = countCurrency / props.rate[typeCurrency];
    props.calcRate(calculated);
  }

  return (
    <div className="Calc">
      <h3> Калькулятор обмена</h3>
      <div className="block">
        <div>
          <form onSubmit={onCalcRate}>
            <input type="number" defaultValue="150" name="count-currency" />
            <select name="type-currency">
              {Object.keys(props.rate).map((keyName, i) => (
                <option key={keyName}>{keyName}</option>
              ))}
            </select>
            <input type='submit' defaultValue="Calc" className="send__data" />
          </form>
        </div>
        <div>
          <h4>Результат</h4>
          <ul className="calc-res">
            <li>{props.base} {props.calculated.toFixed(2)}</li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Calc;
